import React from "react";
import { Card, CardHeader, CardContent, Grid } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from "recharts";
import useGenderHook from "../hooks/GenderHook";

// Define the possible gender categories
const genders = ["Male", "Female", "Other"]; // Add or modify as needed

// Define a fixed color for each gender
const genderColors = {
  Male: "#87CEEB", // Sky Blue
  Female: "#FFB6C1", // Light Pink
  Other: "#32CD32", // Lime Green
};

const Gender = ({ schoolId }) => {
  const { data, loading, error } = useGenderHook(schoolId);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading data</div>;
  }

  // Log the data to ensure it's being fetched correctly
  console.log("Data:", data);

  // Format the data to be used in the bar chart
  const formattedData = data.map((item) => {
    const formattedItem = { ...item };
    // Ensure all gender keys are present, even if the value is 0
    genders.forEach((gender) => {
      if (!formattedItem.hasOwnProperty(gender)) {
        formattedItem[gender] = 0;
      }
    });
    // Convert the values to numbers (not strings with %)
    Object.keys(formattedItem).forEach((key) => {
      if (genders.includes(key)) {
        formattedItem[key] = formattedItem[key] * 100;
      }
    });
    return formattedItem;
  });

  // Debugging: Inspect formattedData
  console.log("formattedData:", formattedData);

  // Define the max value for the Y-axis
  const maxValue = Math.max(
    ...formattedData.flatMap((item) =>
      genders.map((gender) => item[gender] || 0)
    )
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            title="Gender Distribution"
            sx={{ backgroundColor: "#AC1A2F", color: "white" }}
          />
          <CardContent>
            <ResponsiveContainer width="100%" height={400}>
              <BarChart data={formattedData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="Year" interval={0} />
                <YAxis
                  domain={[0, maxValue]}
                  tickFormatter={(value) => `${value}%`}
                />
                <Tooltip formatter={(value) => `${value.toFixed(0)}%`} />
                <Legend />
                {genders.map((gender) => (
                  <Bar
                    key={gender}
                    dataKey={gender}
                    fill={genderColors[gender]}
                  >
                    {/* Remove the cell mapping, it is not needed */}
                  </Bar>
                ))}
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Gender;
